@use '../../../common/styles/mixins.scss';
@use '../../styles/flexMixins';

.btnWrapper {
  display: flex;
  justify-content: flex-end;
}

.wrapper {
  margin: 20px 0;
  width: 100%;
  overflow: visible;
}

.wrapper > .bb > svg {
  overflow: visible !important;
}

.bb-title {
  position: relative;
  top: -10px;
}

.region6 {
  background-color: #cc00ff;
  stroke: #cc00ff;
  fill: #cc00ff;
}

.spinner-style {
  width: 100%;
  text-align: center;
}

.MuiCircularProgress-colorPrimary {
  color: #c30a14 !important;
}

.legend_tile {
  display: inline-block;
  padding: 5px;
}

.legend_text {
  color: #686868;
  margin-left: 5px;
  vertical-align: unset;
}

.legend_container {
  @include mixins.flexColumnItemsCenter();
}

.robot-chart-wrapper #chart_milking_state {
  width: 1460px;
  .region0 {
    background-color: #8470ff;
    stroke: #8470ff;
    fill: #8470ff;
  }

  .region1 {
    background-color: #6ed0e0;
    stroke: #6ed0e0;
    fill: #6ed0e0;
  }

  .region2 {
    background-color: #ffd700;
    stroke: #ffd700;
    fill: #ffd700;
  }

  .region3 {
    background-color: #ff4040;
    stroke: #ff4040;
    fill: #ff4040;
  }

  .region4 {
    background-color: #1f78c1;
    stroke: #1f78c1;
    fill: #1f78c1;
  }

  .region5 {
    background-color: #bada55;
    stroke: #bada55;
    fill: #bada55;
  }
}

#chart_milk_handling_state {
  .region0 {
    background-color: #ffd700;
    stroke: #ffd700;
    fill: #ffd700;
  }

  .region1 {
    background-color: #6ed0e0;
    stroke: #6ed0e0;
    fill: #6ed0e0;
  }

  .region2 {
    background-color: #bada55;
    stroke: #bada55;
    fill: #bada55;
  }
}

#chart_milking_state {
  border-radius: 4px;
}
#chart_cow_handling_state {
  .region0 {
    background-color: #6ed0e0;
    stroke: #6ed0e0;
    fill: #6ed0e0;
  }

  .region1 {
    background-color: #bada55;
    stroke: #bada55;
    fill: #bada55;
  }

  .region2 {
    background-color: #800080;
    stroke: #800080;
    fill: #800080;
  }

  .region3 {
    background-color: #1f78c1;
    stroke: #1f78c1;
    fill: #1f78c1;
  }

  .region4 {
    background-color: #ffd700;
    stroke: #ffd700;
    fill: #ffd700;
  }
}

#chart_arm_state {
  .region0 {
    background-color: #1f78c1;
    stroke: #1f78c1;
    fill: #1f78c1;
  }

  .region1 {
    background-color: #6ed0e0;
    stroke: #6ed0e0;
    fill: #6ed0e0;
  }

  .region2 {
    background-color: #ffd700;
    stroke: #ffd700;
    fill: #ffd700;
  }

  .region3 {
    background-color: #bada55;
    stroke: #bada55;
    fill: #bada55;
  }
}

#chart_fluids_destinatoin {
  .region0 {
    background-color: #bada55;
    stroke: #bada55;
    fill: #bada55;
  }
}

#chart_system_state {
  .region0 {
    background-color: #ff4040;
    stroke: #ff4040;
    fill: #ff4040;
  }
  .region1 {
    background-color: #bada55;
    stroke: #bada55;
    fill: #bada55;
  }
  .region2 {
    background-color: #636466;
    stroke: #636466;
    fill: #636466;
  }
  .region3 {
    background-color: #ffff66;
    stroke: #ffff66;
    fill: #ffff66;
  }
  .region4 {
    background-color: #ffd700;
    stroke: #ffd700;
    fill: #ffd700;
  }
}

.robot-chart-wrapper #chart_milking_state .bb-zoom-rect {
  opacity: 1 !important;
  width: 0.4px;
}
